/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .errors-tooltip[_ngcontent-%COMP%]{background:url(/assets/img/combined-shape.svg);position:absolute;left:50px;top:0;font-size:15px}"];
export { styles as styles };
